import React, { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import Seo from "../components/Seo";
import { Mail, MessageSquare, User, Building2 } from "lucide-react";

const Field = ({ label, icon: Icon, children }) => (
  <label className="block">
    <span className="kicker flex items-center gap-1.5"><Icon size={12}/> {label}</span>
    {children}
  </label>
);

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Received. Our editorial team will respond shortly.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Unable to send. Please try again."); }
    finally { setLoading(false); }
  };

  const input = "mt-2 w-full border border-[var(--io-border)] focus:border-[var(--io-gold)] bg-[var(--io-bg-2)] rounded-md px-4 py-3 text-[14px] outline-none text-[var(--io-text)] placeholder:text-[var(--io-muted)]";

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-14" data-testid="contact-page">
      <Seo
        title="Contact"
        description="Get in touch with the IndiaODR editorial desk — corrections, tips, partnerships, media enquiries."
        path="/contact"
      />
      <div className="eyebrow" style={{ color: "#D4AF37" }}>Contact</div>
      <h1 className="font-serif text-[44px] md:text-[56px] mt-2 text-[var(--io-text)]">Get in touch</h1>
      <p className="text-[15px] text-[var(--io-text-2)] max-w-[60ch] mt-3">For editorial queries, corrections, tips, institutional partnerships, or media enquiries, write to us.</p>

      <form onSubmit={submit} className="mt-10 grid md:grid-cols-2 gap-5" data-testid="contact-form">
        <Field label="Name" icon={User}>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={input} placeholder="Jane Doe" data-testid="contact-name"/>
        </Field>
        <Field label="Email" icon={Mail}>
          <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} placeholder="jane@firm.com" data-testid="contact-email"/>
        </Field>
        <div className="md:col-span-2"><Field label="Subject" icon={Building2}>
          <input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className={input} placeholder="Correction / tip / partnership" data-testid="contact-subject"/>
        </Field></div>
        <div className="md:col-span-2"><Field label="Message" icon={MessageSquare}>
          <textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className={input} placeholder="How can we help?" data-testid="contact-message"/>
        </Field></div>
        <div className="md:col-span-2">
          <button disabled={loading} className="btn btn-primary" data-testid="contact-submit">
            {loading ? "Sending…" : "Send message"}
          </button>
        </div>
      </form>
    </div>
  );
}
